module.exports = __webpack_public_path__ + "../resources/img/pro.9776597c.svg";